const topicSlug = {
  ucetni: 'samostatna-ucetni/',
  danovyPoradce: 'danovy-poradce/',
  asistent: 'asistent/'
}

export const Content = {
  ucetni: {
    title: 'Samostatná účetní',
    slug: topicSlug.ucetni,
    description: `Máte zkušenosti s vedením finančního účetnictví? Pojďte se dále rozvíjet do přátelského týmu v centru Jihlavy. Nabízíme různorodou práci, zkušené kolegy a možnost se profesně posouvat.`
  },
  danovyPoradce: {
    title: 'Daňový poradce',
    slug: topicSlug.danovyPoradce,
    description:
      'V týmu přivítáme kolegu s praxí v oboru daní a účetnictví a ochotou se učit. Vaší prací bude zejména poradenství v oblasti DPPO, DPH, případně jiné specializaci. Spolupracovat budete se zkušenými kolegy.'
  },
  asistent: {
    title: 'Asistent',
    slug: topicSlug.asistent,
    description:
      'Získejte možnost nahlédnout hlouběji do oboru a učit se od profesionálních daňových poradců. Vaší prací budou zejména rešerše, zpracování daňových přiznání a vedení účetnictví.'
  }
}
export default Content
